import { Modal, Typography } from "@material-ui/core";
import React from "react";
import { formatCurrency } from "../../../utils/format";
import { Button } from "../../Button";
import useStyles from "./styles";

interface CancellationConfirmationModalProps {
  open: boolean;
  orderCount: number;
  totalAmount: number;
  isLoading: boolean;
  onDismiss: () => void;
  onConfirm: () => void;
}

export const CancellationConfirmationModal: React.FC<
CancellationConfirmationModalProps
> = ({
  open,
  orderCount,
  totalAmount,
  isLoading,
  onDismiss,
  onConfirm,
}) => {
  const styles = useStyles();
  const message = `Este pagamento gerou ${orderCount} pedidos. Ao continuar, todos os pedidos relacionados serão cancelados e o pagamento completo de ${formatCurrency(totalAmount / 100)} será estornado.`;

  return (
    <Modal
      className={styles.modal}
      open={open}
      onClose={isLoading ? undefined : onDismiss}
      disableEscapeKeyDown={isLoading}
    >
      <div className={styles.content}>
        <Typography className={styles.title}>
          Cancelar pagamento completo?
        </Typography>
        <Typography className={styles.message}>
          {message}
        </Typography>
        <div className={styles.actions}>
          <Button
            color="secondary"
            disabled={isLoading}
            onClick={onDismiss}
          >
            Voltar
          </Button>
          <Button disabled={isLoading} onClick={onConfirm}>
            {isLoading ? "Cancelando..." : "Cancelar todos os pedidos"}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
